import { cx } from '@linaria/core';
import { useId } from 'react';
import { resets } from '@ui/css';
import { printHtmlNodesToJsx } from '@utils/ast';
import { Caption } from '../atoms/Caption.js';
import { AudioComponentContent } from './audio-component.content.js';
import { Scrambled } from './audio-component.scrambled.js';
import { wrapperCls } from './audio-component.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const AudioComponentSelector = "audio-component";
function AudioComponent(props) {
  const id = useId();
  let content;
  if (props.isScrambled) {
    content = /*#__PURE__*/jsx(Scrambled, {});
  } else {
    content = /*#__PURE__*/jsx(AudioComponentContent, {
      ...props
    });
  }
  return /*#__PURE__*/jsxs("section", {
    "data-component-type": AudioComponentSelector,
    className: cx("gAudio", resets.rootCls, wrapperCls, props.isScrambled && "scrambled"),
    "aria-details": props.transcript && !props.isScrambled ? `transcript-${id}` : undefined,
    children: [props.displayCaption === "above" && /*#__PURE__*/jsx(Caption, {
      caption: props.caption,
      displayCaption: props.displayCaption,
      isScrambled: props.isScrambled,
      displayInternalInfoInPlayer: props.displayInternalInfoInPlayer
    }), content, props.displayCaption === "below" && /*#__PURE__*/jsx(Caption, {
      caption: props.caption,
      displayCaption: props.displayCaption,
      isScrambled: props.isScrambled,
      displayInternalInfoInPlayer: props.displayInternalInfoInPlayer
    }), props.transcript && !props.isScrambled && /*#__PURE__*/jsx("aside", {
      className: resets.screenReaderOnlyCls,
      id: `transcript-${id}`,
      children: /*#__PURE__*/jsx("div", {
        children: printHtmlNodesToJsx(props.transcript)
      })
    })]
  });
}

export { AudioComponent, AudioComponentSelector };
//# sourceMappingURL=audio-component.js.map
